import _ from 'lodash';
import { Badge, Col, Row } from 'react-bootstrap';
import IconWrapper from '../IconWrapper';
import { displayTime } from '../../commons/utils/customTable.util';
import { displayDate } from '../../commons/utils/date.util';
import { ICustomTableCellProps } from './interfaces';
import { HiOutlinePencil, HiOutlineTrash } from 'react-icons/hi';
import { ReactNode } from 'react';
import { BiExport, BiUserPlus, BiChat } from 'react-icons/bi';

const CustomTableCell = <T extends { role?: 'MANAGER' | 'ADMIN' }>({
  item,
  columnMetadata,
  onClick
}: ICustomTableCellProps<T>) => {
  const value = _.get(item, columnMetadata.key);

  const renderDateCase = () => {
    if (!value) return '--';
    return displayDate(value, 'DD/MM/YYYY');
  };

  const renderTimeCase = () => {
    return displayTime(value);
  };

  const renderStatusCase = () => {
    return (
      <Badge pill bg={columnMetadata.statusMap?.[value].background}>
        {columnMetadata.statusMap?.[value].text}
      </Badge>
    );
  };

  const renderActionCase = () => {
    return (
      <Row className="me-0">
        {_.map(columnMetadata.actions, (actionType) => {
          const handleClick = () => {
            onClick?.(item, actionType);
          };

          let iconToRender: ReactNode;
          console.log(actionType);
          if (actionType === 'EDIT') {
            iconToRender = <HiOutlinePencil />;
          } else if (actionType === 'DELETE' && item.role === 'MANAGER') {
            iconToRender = <HiOutlineTrash />;
          } else if (actionType === 'EXPORT') {
            iconToRender = <BiExport />;
          } else if (actionType === 'ASIGNAR') {
            iconToRender = <BiUserPlus />;
          } else if (actionType === 'CHAT') {
            iconToRender = <BiChat />;
          } else {
            iconToRender = null;
          }

          return (
            <Col key={actionType} md={5} lg="auto">
              <IconWrapper onClick={handleClick} size={26} button>
                {iconToRender}
              </IconWrapper>
            </Col>
          );
        })}
      </Row>
    );
  };

  const renderListCase = () => {
    const list = _.get(item, columnMetadata.key);
    return (
      <Row>
        {_.map(list, (listItem) => {
          return (
            <Col className="ps-0" key={listItem.id}>
              <Badge pill className="me-1 mb-1">
                {listItem.name}
              </Badge>
            </Col>
          );
        })}
      </Row>
    );
  };

  const renderUrlCase = () => {
    return (
      <a href={value} target="_blank" rel="noreferrer">
        .../{value.split('/').pop()}
      </a>
    );
  };

  const renderDatetimeCase = () => {
    if (!value) return '--';
    return displayDate(value, 'DD/MM/YYYY hh:mm');
  };

  const displayCell = () => {
    switch (columnMetadata.type) {
      case 'date': {
        return renderDateCase();
      }
      case 'time': {
        return renderTimeCase();
      }
      case 'status': {
        return renderStatusCase();
      }
      case 'action': {
        return renderActionCase();
      }
      case 'list': {
        return renderListCase();
      }
      case 'url': {
        return renderUrlCase();
      }
      case 'datetime': {
        return renderDatetimeCase();
      }
      case 'truncate': {
        return <p className="cell-truncate">{value}</p>;
      }
      default: {
        return value || '--';
      }
    }
  };

  return <td>{displayCell()}</td>;
};

export default CustomTableCell;
